import { Instagram, Facebook, Twitter, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export function Footer() {
  return (
    <footer id="contato" className="bg-background text-foreground border-t border-border transition-colors duration-300">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Logo and Description */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img 
              src="/lovable-uploads/92641e43-c92a-4a0e-afcd-6e233c81adde.png" 
              alt="K-recão Lanches" 
              className="h-12 sm:h-16 mb-4" 
            />
            <p className="text-gray-700 dark:text-gray-300 mb-4 sm:mb-6 text-sm sm:text-base">
              Oferecendo os melhores hambúrgueres e lanches desde 2010. Qualidade, sabor e atendimento de excelência.
            </p>
            
            {/* Social Media */}
            <div className="flex space-x-3 sm:space-x-4">
              <a 
                href="https://www.instagram.com/krecao_lanches/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-muted hover:bg-[#E1306C] transition-colors rounded-full p-3 group"
                aria-label="Instagram"
              >
                <Instagram size={20} className="text-foreground group-hover:text-white sm:w-6 sm:h-6" />
              </a>
              <a 
                href="https://www.facebook.com/krecaolanches/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-muted hover:bg-[#1877F2] transition-colors rounded-full p-3 group"
                aria-label="Facebook"
              >
                <Facebook size={20} className="text-foreground group-hover:text-white sm:w-6 sm:h-6" />
              </a>
              <a 
                href="https://twitter.com/krecaolanches" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-muted hover:bg-[#1DA1F2] transition-colors rounded-full p-3 group"
                aria-label="Twitter"
              >
                <Twitter size={20} className="text-foreground group-hover:text-white sm:w-6 sm:h-6" />
              </a>
              <a 
                href="https://wa.me/5132422047" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-muted hover:bg-[#25D366] transition-colors rounded-full p-3 group"
                aria-label="WhatsApp"
              >
                <Phone size={20} className="text-foreground group-hover:text-white sm:w-6 sm:h-6" />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4 text-amber-600 dark:text-krecao-yellow">
              Links Rápidos
            </h3>
            <ul className="space-y-2 text-sm sm:text-base">
              <li>
                <a href="#inicio" className="text-gray-700 dark:text-gray-300 hover:text-amber-600 dark:hover:text-krecao-yellow transition-colors">
                  Início
                </a>
              </li>
              <li>
                <a href="#cardapio" className="text-gray-700 dark:text-gray-300 hover:text-amber-600 dark:hover:text-krecao-yellow transition-colors">
                  Cardápio
                </a>
              </li>
              <li>
                <a href="#sobre" className="text-gray-700 dark:text-gray-300 hover:text-amber-600 dark:hover:text-krecao-yellow transition-colors">
                  Sobre Nós
                </a>
              </li>
              <li>
                <a href="#localizacao" className="text-gray-700 dark:text-gray-300 hover:text-amber-600 dark:hover:text-krecao-yellow transition-colors">
                  Localização
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-700 dark:text-gray-300 hover:text-amber-600 dark:hover:text-krecao-yellow transition-colors">
                  Dúvidas Frequentes
                </a>
              </li>
            </ul>
          </div>
          
          {/* Opening Hours */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4 text-amber-600 dark:text-krecao-yellow">
              Horário de Atendimento
            </h3>
            <ul className="space-y-2 text-sm sm:text-base text-gray-700 dark:text-gray-300">
              <li>
                <span className="block font-semibold text-gray-900 dark:text-gray-100">Segunda a Sábado</span>
                <span>11:15h às 23:15h</span>
              </li>
              <li>
                <span className="block font-semibold text-gray-900 dark:text-gray-100">Domingo</span>
                <span>Fechado</span>
              </li>
            </ul>
          </div>
          
          {/* Order Now */}
          <div>
            <h3 className="font-bold text-base sm:text-lg mb-3 sm:mb-4 text-amber-600 dark:text-krecao-yellow">
              Peça Agora
            </h3>
            <p className="text-gray-700 dark:text-gray-300 mb-3 sm:mb-4 text-sm sm:text-base">
              Faça seu pedido diretamente pelo iFood ou WhatsApp e receba no conforto da sua casa.
            </p>
            <div className="space-y-2">
              <Button 
                className="bg-red-600 hover:bg-red-700 text-white w-full text-sm sm:text-base font-medium"
                onClick={() => window.open('https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches-cristal/5a5d2ae1-f8a8-48b8-b1ad-38d5eecbe53f', '_blank')}
              >
                Pedir no iFood
              </Button>
              <Button 
                className="bg-green-600 hover:bg-green-700 text-white w-full text-sm sm:text-base font-medium"
                onClick={() => window.open('https://wa.me/5132422047?text=Olá! Gostaria de fazer um pedido no K-recão Lanches.', '_blank')}
              >
                Pedir pelo WhatsApp
              </Button>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-border mt-8 sm:mt-12 pt-6 sm:pt-8 text-center">
          <p className="text-gray-700 dark:text-gray-300 text-sm sm:text-base">
            &copy; {new Date().getFullYear()} K-recão Lanches. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
